$(function () {

    var controlOfficeLocator = $(".control-office-locator");

    if (controlOfficeLocator.length) {
        $('#contact-region').change(function () {
            var regionId = $(this).val();

            $('#contact-office').val('');
            $('.office-item').removeClass('open');
            $('#contact-office option').not(':first').hide().filter(function () {
                return $(this).data('region') == regionId;
            }).show();

            SetMapMarker(null);
        });

        $('#contact-office').change(function () {
            var officeId = $(this).val();

            $('.office-addresses').addClass('open');
            $('.office-item').removeClass('open');
            if (officeId != '') {
                var officeElement = $('.office-item[data-office="' + officeId + '"]');
                officeElement.addClass('open');

                SetMapMarker(officeElement);
            } else {
                $('.office-addresses').removeClass('open');
                SetMapMarker();
            }
        });

        var tallestItem = Math.max.apply(null, $('.office-item').map(function () { return $(this).height() }));
        $('.office-addresses').css('min-height', tallestItem);
    }
});